export const FACEITEMAREALIMIT = 2000000;//单位平方公里,默认100000

export const WINDFARMAREALIMIT = 5000;
